<template>
    <div v-loading="loading">
        <div class="block">
            备份下载链接：
            <input-set-value
                    ref="setValue"
                    width="450px"
                    :defaultValue="functionList.urlBackupDownload"
                    @my-submit="updateUrl('backup_download_url',$event)"/>
        </div>
        <div class="block">
            游戏公平页面链接：
            <input-set-value
                    ref="setValue"
                    width="450px"
                    :defaultValue="functionList.gameFairBanner"
                    @my-submit="updateUrl('game_fair_banner',$event)"/>
        </div>
        <div class="block">
            常见问题页面链接：
            <input-set-value
                    ref="setValue"
                    width="450px"
                    :defaultValue="functionList.faqUrl"
                    @my-submit="updateUrl('faq_url',$event)"/>
        </div>
        <strong style="padding-top: 30px">功能栏状态：</strong>
        <div class="list">
            <div class="list-item">
                <span class="list-text">钱包功能状态</span>
                <el-switch
                        :value="functionList.switchWallet"
                        active-text="显示"
                        inactive-text="隐藏"
                        :active-value="1"
                        :inactive-value="0"
                        @change="updateStatus('wallet',$event)"/>
            </div>
            <div class="list-item">
                <span class="list-text">分享赚金豆功能状态</span>
                <el-switch
                        :value="functionList.switchPromotion"
                        active-text="显示"
                        inactive-text="隐藏"
                        :active-value="1"
                        :inactive-value="0"
                        @change="updateStatus('promotion',$event)"/>
            </div>
            <div class="list-item">
                <span class="list-text">商城功能状态</span>
                <el-switch
                        :value="functionList.switchMall"
                        active-text="显示"
                        inactive-text="隐藏"
                        :active-value="1"
                        :inactive-value="0"
                        @change="updateStatus('mall',$event)"/>
            </div>
            <div class="list-item">
                <span class="list-text">钱包转豆功能状态</span>
                <el-switch
                        :value="functionList.switchFlow"
                        active-text="显示"
                        inactive-text="隐藏"
                        :active-value="1"
                        :inactive-value="0"
                        @change="updateStatus('flow',$event)"/>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import inputSetValue from 'components/inputSetValue'

    export default {
        components: {
            inputSetValue,
        },
        data(){
          return{
              loading:false
          }
        },
        computed: {
            ...mapState('functionSwitchConfig', ['functionList'])
        },
        created() {
           this.getList()
        },
        methods: {
            ...mapActions('functionSwitchConfig', ['getFunctionList', 'updateSwitchFunction', 'updateUrlSetting']),
            getList(){
                this.loading = true;
                this.getFunctionList().then(()=>{
                    this.loading = false
                })
            },
            // 修改链接
            updateUrl(code, {value, cb}) {
                this.updateUrlSetting({
                    code,
                    value
                }).then(() => {
                    this.$message.success('修改成功');
                    cb()
                })
            },
            // 修改功能栏状态
            updateStatus(code, status) {
                let text = '';
                switch (code) {
                    case 'wallet':
                        text = '钱包功能状态';
                        break;
                    case 'promotion':
                        text = '分享赚金豆功能状态';
                        break;
                    case 'mall':
                        text = '商城功能状态';
                        break;
                    case 'flow':
                        text = '钱包转豆功能状态';
                        break;
                    default:
                        break;

                }
                this.$confirm(`您确定要关闭“${text}”功能吗？关闭后APP端将不再显示该功能`, '系统提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.updateSwitchFunction({code, status}).then(() => {
                        this.$message.success('修改成功')
                    })
                }).catch(() => {
                })

            }
        }
    }
</script>
<style lang="scss" scoped>
    .block {
        height: 40px;
        line-height: 40px;
        font-weight: bold;
    }

    .list {
        flex: 1;
        margin-top: 10px;
        padding: 0 0 30px 50px;
        background-color: $bg-color;
        border-radius: 5px;
        &-text {
            padding-right: 100px;
        }
        &-item {
            display: inline-block;
            height: 50px;
            padding: 0 30px;
            margin-top: 30px;
            margin-right: 50px;
            line-height: 50px;
            text-align: right;
            background-color: #fff;
            border-radius: 5px;
        }
    }
</style>